export var LogLevels;
(function (LogLevels) {
    LogLevels[LogLevels["DEBUG"] = 0] = "DEBUG";
    LogLevels[LogLevels["INFO"] = 1] = "INFO";
    LogLevels[LogLevels["WARN"] = 2] = "WARN";
    LogLevels[LogLevels["ERROR"] = 3] = "ERROR";
})(LogLevels || (LogLevels = {}));
var Log = /** @class */ (function () {
    function Log() {
    }
    Log.error = function (message, err) {
        if (Log.currentLevel <= Log.levels.ERROR) {
            console.error("[ERROR] ".concat(message), err);
        }
        //ToDO: Add Bugsnag stuff here? Include the error?
    };
    Log.warn = function (message) {
        if (Log.currentLevel <= Log.levels.WARN) {
            console.warn("[WARN] ".concat(message));
        }
    };
    Log.info = function (message, obj, obj2) {
        if (Log.currentLevel <= Log.levels.INFO) {
            if (obj === undefined) {
                console.info("[INFO] ".concat(message));
            }
            else {
                if (obj2 === undefined) {
                    console.info("[INFO] ".concat(message), obj);
                }
                else {
                    console.info("[INFO] ".concat(message), obj, obj2);
                }
            }
        }
    };
    Log.debug = function (message, obj, obj2) {
        if (Log.currentLevel <= Log.levels.DEBUG) {
            if (obj === undefined) {
                console.log("[DEBUG] ".concat(message));
            }
            else {
                if (obj2 === undefined) {
                    console.log("[DEBUG] ".concat(message), obj);
                }
                else {
                    console.log("[DEBUG] ".concat(message), obj, obj2);
                }
            }
        }
    };
    Log.levels = LogLevels;
    Log.currentLevel = parseInt(process.env.REACT_APP_LOG_LEVEL);
    return Log;
}());
export default Log;
